import React from "react";
import { Col, Row } from "reactstrap";
import DashPanel from "../common/DashPanel";
import SectionTitle from "../common/SectionTitle";
import StatBadgeRow from "../common/StatBadgeRow";
import ChipRow from "../common/ChipRow";
import LeaderboardRow from "../common/LeaderboardRow";
import InlineBarChart from "../charts/InlineBarChart";
import { fmtINR, fmtNum } from "../../utils/formatters";
import { T } from "../../constants/theme";
import { posData } from "../../data/dashboardMockData";

const LEADERBOARD_COLORS = [
  T.blue,
  T.green,
  T.teal,
  T.yellow,
  T.orange,
  T.purple,
  "#02a499",
  T.red,
];

const PosOverviewSection = ({ loading }) => (
  <Row className="super-admin-row-stretch">
    <Col xl={6} className="d-flex">
      <DashPanel
        title="POS Overview"
        icon="bx bx-store-alt"
        iconColor={T.green}
        loading={loading}
      >
        <StatBadgeRow
          items={[
            { label: "Total Machines", value: posData.machines.total, color: T.blue },
            { label: "Active", value: posData.machines.active, color: T.green },
            { label: "Inactive", value: posData.machines.inactive, color: T.yellow },
            { label: "Expired", value: posData.machines.expired, color: T.red },
            { label: "Empty", value: posData.machines.empty, color: T.orange },
          ]}
          loading={loading}
        />

        <SectionTitle>Firmware Status</SectionTitle>
        <ChipRow
          items={[
            { label: "Up to date", value: posData.machines.updated, color: T.green },
            { label: "Needs update", value: posData.machines.nonUpdated, color: T.yellow },
            {
              label: "Usage this month",
              value: `${posData.machines.usagePercent}%`,
              color: T.blue,
            },
          ]}
        />

        <SectionTitle>Daily Sale Trend (Last 7 Days)</SectionTitle>
        <InlineBarChart
          data={posData.dailySaleTrend}
          labelKey="date"
          valueKey="amount"
          color={T.green}
          formatValue={(v) => `₹${(v / 1000).toFixed(0)}k`}
          loading={loading}
        />
      </DashPanel>
    </Col>

    <Col xl={6} className="d-flex">
      <DashPanel
        title="Franchise Leaderboard"
        icon="bx bx-trophy"
        iconColor={T.yellow}
        loading={loading}
      >
        <SectionTitle>Top Performing Franchises</SectionTitle>
        <div className="sad-scroll-list">
          {posData.franchiseLeaderboard.map((f, i) => (
            <LeaderboardRow
              key={i}
              rank={f.rank}
              label={f.name}
              value={fmtINR(f.sale)}
              sub={`${fmtNum(f.transactions)} txns`}
              growth={f.growth}
              color={LEADERBOARD_COLORS[i % 8]}
              isTop={i === 0}
              loading={loading}
            />
          ))}
        </div>
      </DashPanel>
    </Col>
  </Row>
);

export default PosOverviewSection;
